import { HubTileID } from '@office-start/appbar-types';
/**
 * getReferralFromElementId gets the referral from the elementId.
 * referral is used by the telemetry instrumentation-service.
 * @param elementId The Id of the element that was clicked, such as "office_mycontent", "office_outlook", "office_teams", "office_word"
 * @return The Referral definition of the elementId for telemetry to use.
 */
var referralDefinition = {
    office_calendar: "Calendar" /* KnownWorkloadReferralNames.Calendar */,
    office_create: "Create" /* KnownWorkloadReferralNames.Create */,
    office_excel: "ExcelOnline" /* KnownWorkloadReferralNames.Excel */,
    office_cluid: "Fluid" /* KnownWorkloadReferralNames.Fluid */,
    office_forms: "OfficeForms" /* KnownWorkloadReferralNames.Forms */,
    office_mail: "Mail" /* KnownWorkloadReferralNames.Mail */,
    office_mycontent: "MyContent" /* KnownWorkloadReferralNames.MyContent */,
    office_feed: "Feed" /* KnownWorkloadReferralNames.Feed */,
    office_ondrive: "Documents" /* KnownWorkloadReferralNames.OneDrive */,
    office_onenote: "OneNoteOnline" /* KnownWorkloadReferralNames.OneNote */,
    office_outlook: "Mail" /* KnownWorkloadReferralNames.Mail */,
    office_powerbi: "PowerBIv2" /* KnownWorkloadReferralNames.PowerBI */,
    office_powerpoint: "PowerPointOnline" /* KnownWorkloadReferralNames.PowerPoint */,
    office_project: "Project" /* KnownWorkloadReferralNames.Project */,
    office_sharepoint: "Sites" /* KnownWorkloadReferralNames.SharePoint */,
    office_skype: "Skype" /* KnownWorkloadReferralNames.Skype */,
    office_sway: "Sway" /* KnownWorkloadReferralNames.Sway */,
    office_teams: "SkypeTeams" /* KnownWorkloadReferralNames.Teams */,
    office_visio: "VisioOnline" /* KnownWorkloadReferralNames.Visio */,
    office_word: "WordOnline" /* KnownWorkloadReferralNames.Word */,
    park: "Park" /* KnownWorkloadReferralNames.Park */,
};
// Add on a mapping of App Bar hub tile IDs to known workload referral names.
referralDefinition[HubTileID.admin] = "AdminPortal" /* KnownWorkloadReferralNames.AdminPortal */;
referralDefinition[HubTileID.appgallery] =
    "AppGallery" /* KnownWorkloadReferralNames.AppGallery */;
referralDefinition[HubTileID.calendar] = "Calendar" /* KnownWorkloadReferralNames.Calendar */;
referralDefinition[HubTileID.clipchamp] = "Clipchamp" /* KnownWorkloadReferralNames.Clipchamp */;
referralDefinition[HubTileID.create] = "Create" /* KnownWorkloadReferralNames.Create */;
referralDefinition[HubTileID.excel] = "ExcelOnline" /* KnownWorkloadReferralNames.Excel */;
referralDefinition[HubTileID.familysafety] =
    "FamilySafety" /* KnownWorkloadReferralNames.FamilySafety */;
referralDefinition[HubTileID.feed] = "Feed" /* KnownWorkloadReferralNames.Feed */;
referralDefinition[HubTileID.forms] = "OfficeForms" /* KnownWorkloadReferralNames.Forms */;
referralDefinition[HubTileID.home] = "OfficeDotCom" /* KnownWorkloadReferralNames.OfficeDotCom */;
referralDefinition[HubTileID.lists] = "Lists" /* KnownWorkloadReferralNames.Lists */;
referralDefinition[HubTileID.mycontent] = "MyContent" /* KnownWorkloadReferralNames.MyContent */;
referralDefinition[HubTileID.onedrive] = "Documents" /* KnownWorkloadReferralNames.OneDrive */;
referralDefinition[HubTileID.onenote] = "OneNoteOnline" /* KnownWorkloadReferralNames.OneNote */;
referralDefinition[HubTileID.outlook] = "Mail" /* KnownWorkloadReferralNames.Mail */;
referralDefinition[HubTileID.people] = "People" /* KnownWorkloadReferralNames.People */;
referralDefinition[HubTileID.powerautomate] =
    "LogicFlows" /* KnownWorkloadReferralNames.LogicFlows */;
referralDefinition[HubTileID.powerpoint] =
    "PowerPointOnline" /* KnownWorkloadReferralNames.PowerPoint */;
referralDefinition[HubTileID.skype] = "Skype" /* KnownWorkloadReferralNames.Skype */;
referralDefinition[HubTileID.stream] =
    "MicrosoftStream" /* KnownWorkloadReferralNames.MicrosoftStream */;
referralDefinition[HubTileID.sway] = "Sway" /* KnownWorkloadReferralNames.Sway */;
referralDefinition[HubTileID.teams] = "SkypeTeams" /* KnownWorkloadReferralNames.Teams */;
referralDefinition[HubTileID.todo] = "ToDo" /* KnownWorkloadReferralNames.ToDo */;
referralDefinition[HubTileID.visio] = "VisioOnline" /* KnownWorkloadReferralNames.Visio */;
referralDefinition[HubTileID.word] = "WordOnline" /* KnownWorkloadReferralNames.Word */;
export function getReferralFromElementId(elementId) {
    if (!elementId) {
        return '';
    }
    var referral = referralDefinition[elementId];
    return referral !== null && referral !== void 0 ? referral : elementId;
}
//# sourceMappingURL=getReferralFromElementId.js.map